import extendNode from '../extendNode.mjs'
import useComponentNode from '../_COMPONENT/useComponentNode.jsx'
import meta from './metaRulemrmrule.mjs'
import Model from './ModelRulemrmrule.mjs'
import PropertiesPane from './PropertiesPaneRulemrmrule.jsx'
import RuleType from './RuleType.jsx'

const ruleTypes = new Map(
    RuleType.map(([type, name, icon]) => [type, {icon, name, type}])
)

export default () => {
    const ComponentNode = useComponentNode()

    return extendNode(ComponentNode, {
        ...meta,
        Model,
        PropertiesPane,

        canMountType(map, node, type) {
            return (
                /^(AR)$/.test(type) ||
                ComponentNode.canMountType.call(this, map, node, type)
            )
        },

        getIcons(map, node) {
            const {ruleType} = node.data
            const {icon} = ruleTypes.get(ruleType) ?? {}

            if (icon) {
                return [icon]
            }
            else {
                return []
            }
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'AR'},
            ]
        },

        async _atOwnerPush(map, node, event) {
            const d = await this._getPushData(map, node)
            event.detail.rulemRmRules.push(d)
        },

        //_getDefaultDataFields(map, node) {
            //const ruleType = (() => {
                //for (const n of node.chain) {
                    //const {bizNodeType, rmType} = n.data

                    //if ('RULEMRM' === bizNodeType) {
                        //return 'ROLE' === rmType ? 'ROLE' : 'GENERAL'
                    //}
                //}
            //})()

            //return {
                //...ComponentNode._getDefaultDataFields.call(this, map, node),
                //ruleType,
            //}
        //},
    })
}
